export const TAB_LEAVE_BALANCE = "leave-balance";
export const TAB_FINAL_APPROVAL = "final-approval";
export const TAB_PUNCH_DETAILS = "punch-details";

export const LEAVE_ATTENDANCE_TABS = [
  { id: TAB_LEAVE_BALANCE, label: "Leave Update" },
  { id: TAB_FINAL_APPROVAL, label: "Approve Leave (HR)" },
  { id: TAB_PUNCH_DETAILS, label: "Punch Details" },
] as const;

export type LeaveAttendanceTabId = (typeof LEAVE_ATTENDANCE_TABS)[number]["id"];

export const LEAVE_STATUS_OPTIONS = [
  { value: "PENDING", label: "Pending" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
  { value: "WITHDRAW", label: "Withdrawn" },
  { value: "MANAGER_PENDING", label: "Pending (Manager)" },
];

